import React from 'react';

import {SessionActivityName} from 'interfaces';
import {UrlService} from 'services';
import {ClientSessionParams} from 'types';
import {versionUtils} from 'utils';

import {WithClientSessionParams} from './with-client-session-params';

const initialState: WithClientSessionParams & {mounted: boolean} = {
    clientSessionParamsQuery: null,
    clientSessionParams: null,
    mounted: false
};

const ACTIVITY_SUPPORTED_FROM_LIVE_HELP_VERSION = '1.6';

export const withClientSessionParamsFromUrl = () => <P extends WithClientSessionParams>(Component: React.ComponentType<P>) =>
    class WithClientSessionParamsFromUrl extends React.Component<P & WithClientSessionParams> {
        readonly state = initialState;

        componentDidMount() {
            const clientSessionParamsQuery = window.location.search;

            const clientSessionParams: ClientSessionParams = {
                userInfo: this.extractSearchParamJsonValueBase64('userInfo'),
                meta: this.extractSearchParamJsonValueBase64('meta'),
                assignmentInfo: this.extractSearchParamJsonValueBase64('assignmentInfo'),
                agentInfo: this.extractSearchParamJsonValueBase64('agentInfo'),
                integrationInfo: this.extractSearchParamJsonValueBase64('integrationInfo'),
                liveHelpMode: this.extractSearchParamValue('mode'),
                requestedActivity: this.extractSearchParamValue('activity') as SessionActivityName,
            };

            if (versionUtils.isLess(clientSessionParams.meta?.liveHelpVersion, ACTIVITY_SUPPORTED_FROM_LIVE_HELP_VERSION)) {
                clientSessionParams.requestedActivity = SessionActivityName.TextChat;
            }

            this.setState({
                clientSessionParamsQuery,
                clientSessionParams,
                mounted: true
            });
        }

        extractSearchParamJsonValueBase64 = (paramName: string) => {
            const value = UrlService.getSearchParamJsonValueBase64(paramName);
            UrlService.removeSearchParam(paramName);
            return value;
        };

        extractSearchParamValue = (paramName: string) => {
            const value = UrlService.getSearchParamValue(paramName);
            UrlService.removeSearchParam(paramName);
            return value;
        };

        render() {
            const {clientSessionParamsQuery, clientSessionParams, mounted} = this.state;

            if (!mounted) {
                return null;
            }

            return (
                <Component
                    {...this.props}
                    clientSessionParamsQuery={clientSessionParamsQuery}
                    clientSessionParams={clientSessionParams}
                />
            );
        }
    };
